import * as Yup from 'yup';

export const ScheduleDeliverySchema = Yup.object().shape({
    id: Yup.string(),
    scheduledDate: Yup.string().min(2).required('Please provide deliveryDate'),
});

export type ScheduleDeliveryDataType = Yup.InferType<typeof ScheduleDeliverySchema>;

type InitialValues = {
    id: string;
    scheduledDate: string;
};

export const scheduleDeliveryInitialValues: InitialValues = {
    id: '',
    scheduledDate: '',
};



export interface IScheduleDeliveryResponse {
    id: string;
    scheduledDate: string;
}

export interface IScheduleDeliveryRequest {
    id: string;
    scheduledDate: string;
}
